import Backbone from "backbone";
import TeamView from "./team";

export default class NavigationView extends Backbone.View {
    events() {
        return {
            "mouseover .dropdown": "show",
            "click .dropdown": "toggle",
            "click .collapse-toggle": "collapseToggle",
            "mouseleave .dropdown": "hide",
            "click .flag-picker": "toggleFlags"
        }
    }

    toggle(event) {
        if ($(event.target).closest(".subnav").length) {
            return true;
        }

        if ($(window).width() < 767) {
            event.preventDefault();
            $(event.target).closest(".dropdown").find(".subnav").slideToggle();
        }

    }

    collapseToggle(event) {
        event.preventDefault();
        this.$el.find(".phone-collapse").slideToggle();
    }

    show(event) {
        if ($(window).width() > 767) {
            $(event.target).closest(".dropdown").addClass("hover").find(".subnav").fadeIn();
        }
    }

    hide(event) {
        if ($(window).width() > 767) {
            $(event.target).closest(".dropdown").removeClass("hover").find(".subnav").fadeOut();
        }
    }
    hideFlags() {
        this.$flags.animate({"opacity": 0, "top": "30px"}, function () {
            this.$flags.hide().css("top", "0px");
        }.bind(this));
    }

    showFlags() {
        this.$flags.show().animate({"opacity": 1, "top": "40px"});
    }

    toggleFlags(event) {
        if (!this.$flags.is(":visible")) {
            this.showFlags();
        } else {
            this.hideFlags();
        }
    }


    initialize(options) {
        var $more = this.$el.find(".more .subnav");

        this.$flags = this.$el.find(".flag-picker ul");
        this.$el.find(".desktop-only").each(function () {
            let $el = $(this).clone();
            $more.removeClass("desktop-only");
            $el.appendTo($more);
        });
        $(document).click(function (e) {

            if (!$(e.target).hasClass('flag-picker') && !$(e.target).closest(".flag-picker").length) {
                if (this.$flags.is(":visible")) {
                    this.hideFlags();
                }
            }
        }.bind(this))
    }
}



// WEBPACK FOOTER //
// ./frontend/js/views/navigation.js